import { Component } from "@angular/core";
import { MatCheckboxDefaultOptions, MAT_CHECKBOX_DEFAULT_OPTIONS } from "@angular/material/checkbox";
import { Address } from "@app/address/model/address";
import { AddressUtilityService } from "@app/address/services/address.utility.service";
import { finalize } from "rxjs/operators";

@Component({
    selector: "address-chooser",
    templateUrl: "./address-chooser.component.html",
    styleUrls: ["./address-chooser.component.scss"],
    providers: [
        {
            provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
            useValue: { clickAction: "noop" } as MatCheckboxDefaultOptions,
        },
    ],
})
export class AddressChooserComponent {
    addresses: Address[];
    selectedAddress: Address;
    appliedLocationData = false;
    city = "";
    country = "";
    zipcode = "";
    isLoading = false;

    constructor(private readonly addrUtility: AddressUtilityService) {}

    isSelectedAddress(id: number) {
        return this.selectedAddress?.id === id;
    }

    selectAddress(addr: Address) {
        if (!this.isSelectedAddress(addr.id)) {
            this.selectedAddress = addr;
        }
    }

    applySearch(event) {
        event.preventDefault();
        this.isLoading = true;
        this.addrUtility
            .lookupAddress({ zipcode: this.zipcode, city: this.city, country: this.country })
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((addresses: Address[]) => {
                this.addresses = addresses;
                if (this.addresses.length) {
                    this.selectedAddress = addresses[0];
                }
                this.appliedLocationData = true;
            });
    }
}
